import { useEffect, useState } from 'react';
import ROS from '../components/RevealOnScroll';
import defaultImg from '../img/pse_jru.png';

export default function ProductSeparator({name = ""}) {
    const [isSmall, setIsSmall] = useState(false);
    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 640px)');
        const handleChange = () => setIsSmall(!mediaQuery.matches);
        mediaQuery.addEventListener('change', handleChange);
        handleChange();
    }, []);

    var width = "calc( 50% + 320px )";
    var centerer= "";
    var l = "pl-2";
    if(isSmall){
        width = "100%";
        centerer = "text-center";
        l= "";
    }



    return (
        <ROS className='w-full'>
            <span class="flex items-center w-full mt-5 mx-16 p-4">
                <span class="h-px p-1 flex-1 bg-gray-300 rounded-lg"></span>

                <span class="shrink-0 px-4 text-gray-900 bg-orange-100 border border-gray-200 rounded-lg shadow-sm mx-5">{name}</span>

                <span class="h-px p-1 flex-1 bg-gray-300 rounded-lg"></span>
            </span>
        </ROS>
    )
}